import React, {useEffect, useState} from "react";
import {withStyles} from "@material-ui/core";
import Collapse from '@material-ui/core/Collapse';
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import Typography from "@material-ui/core/Typography";
import Icon from "@material-ui/core/Icon";
import IconButton from "@material-ui/core/IconButton";
import TableRowClickable from "../Form/TableRowClickable";
import i18n from "../../i18n";
import EllipsisWithTooltip from "../Formater/EllipsisWithTooltip";
import TowLine from "../Text/TwoLine";
import ProjectStatusText from "../Project/ProjectStatusText";
import TablePagination from "@material-ui/core/TablePagination";
import {lighten} from "@material-ui/core/styles/colorManipulator";
import FormaterDate from "../Formater/Date";

// for table sortable
/*
function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}
*/

const TableRowCollapse = (props) => {

    const {values,detail,show,classes} = props;

    let projects = values.projects;
    if(values.filtered && values.filtered.length){
        projects = values.filtered;
    }

    const [open,setOpen] = useState(false);
    const handleClick = () => {
        setOpen(!open);
    }

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    useEffect(()=> {
        if(projects && projects.length) {
            setOpen(show);
        }
    },[projects,show]);

    return (
        <React.Fragment>
            <TableRowClickable
                action={`/construction/${values.id}`}
                key={`buildingData_${values.id}`}
                style={{
                    border: (open ? '1px solid #000' :'unset'),

                }}
            >
                {detail && (
                    <TableCell align="center" onClick={ e => { e.stopPropagation('all'); } }  style={{cursor:'default'}}>
                        {projects.length ? (
                            <Typography component={'h6'}>
                                {projects.length}
                                <IconButton
                                    className={classes.iconButton}
                                    component={'a'}
                                    onClick={handleClick} aria-label="expand row" size="small">
                                    <Icon className={classes.iconButtonIcon}>
                                        {open ? 'expand_less' : 'expand_more' }
                                    </Icon>
                                </IconButton>
                            </Typography>
                        ) : ''}
                    </TableCell>
                )}
                <TableCell>
                    <Typography component={'h6'}>
                        {values.name}
                    </Typography>
                </TableCell>
                <TableCell>
                    <Typography component={'h6'}>
                        {values.city}, {values.street} {values.number}
                    </Typography>
                </TableCell>
                <TableCell align="center" onClick={ e => { e.stopPropagation('all'); } } style={{cursor:'default'}}>
                    <IconButton
                        className={classes.iconButton}
                        href={`/construction/${values.id}/edit`}
                        dusk={`edit-values${values.id}`}
                        size={'small'}>
                        <Icon className={classes.iconButtonIcon}>edit</Icon>
                    </IconButton>
                </TableCell>
            </TableRowClickable>
            {detail && (
                <TableRow key={`projectData_${values.id}`} style={ { height:0, background:'unset', } } className={classes.root}>

                    <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={4}>
                        <Collapse in={open} timeout="auto" unmountOnExit>
                            <div style={{marginLeft:20,marginRight:20}}>
                                <Table size="small" aria-label="purchases" className={classes.root}>
                                    <TableHead>
                                        <TableRow style={{background:'unset',}}>
                                            <TableCell style={{ width:'40%' }}>{i18n.get('deficiency.self_plural')}</TableCell>
                                            <TableCell style={{ width:'20%' }}>{i18n.get('deficiency.subcontractor')}</TableCell>
                                            <TableCell style={{ width:'15%' }}>{i18n.get('deficiency.status')}</TableCell>
                                            <TableCell align="center">{i18n.get('deficiency.reminder')}</TableCell>
                                            <TableCell align="center">{i18n.get('deficiency.actions')}</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody >
                                        {projects.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((item) => (
                                            <TableRowClickable action={`/project/${item.project.id}`} key={`project_${item.project.id}`} >
                                                <TableCell>
                                                    <Typography component={'h6'}>
                                                        <EllipsisWithTooltip>
                                                            {item.project.name}
                                                        </EllipsisWithTooltip>
                                                    </Typography>
                                                    <TowLine
                                                        sub={item.project.number_internal}
                                                    />
                                                </TableCell>
                                                <TableCell>
                                                    <Typography component={'h6'}>
                                                        <EllipsisWithTooltip>
                                                            {item.project.contacts && item.project.contacts.length && item.project.contacts[0].contact.company_name}
                                                        </EllipsisWithTooltip>
                                                    </Typography>
                                                </TableCell>
                                                <TableCell>
                                                    <ProjectStatusText status={item.project.status} size="small" />
                                                </TableCell>
                                                <TableCell align={'center'}>
                                                    <Typography component={'h6'}>
                                                        {item.project.reminder && (<FormaterDate value={item.project.reminder} />)}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell align={'center'} onClick={ e => { e.stopPropagation('all'); } } style={{cursor:'default'}}>
                                                    <IconButton
                                                        component="a"
                                                        href={`/project/${item.project.id}/edit`}
                                                    >
                                                        <Icon>edit</Icon>
                                                    </IconButton>
                                                </TableCell>
                                            </TableRowClickable>
                                        ))}
                                    </TableBody>
                                </Table>
                            </div>
                            <TablePagination
                                rowsPerPageOptions={[5, 10, 25]}
                                labelRowsPerPage={i18n.get('deficiency.rows_per_page')}
                                labelDisplayedRows={
                                    ({ from, to, count }) =>
                                        i18n.get('deficiency.displayed_rows',{
                                            from: from + '' ,
                                            to: to + '',
                                            count: count + ''
                                        })
                                }
                                nextIconButtonProps={{size:'small'}}
                                backIconButtonProps={{size:'small'}}
                                component="div"
                                count={projects.length}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                onChangePage={handleChangePage}
                                onChangeRowsPerPage={handleChangeRowsPerPage}
                            />
                        </Collapse>
                    </TableCell>
                </TableRow>
            )}
        </React.Fragment>
    );
}

const styles = theme => ({
    root: {
        hover: {
            background: 'unset !important',
            border: '1px solid #f39812',
        },
        '& > *': {
            borderBottom: 'unset',
        },
        '& tbody tr:hover': {
            backgroundColor: lighten(theme.colors.lightGreyBlue, 0.8),
        },
    },
});

export default withStyles(styles)(TableRowCollapse);
